import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { AbstractPort, Port } from '../fields/AbstractPort';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const port = AbstractPort.extend({
    AC: Port.AC.default({}),
    DC: Port.DC.default({}),
    powerFlowDirection: Port.powerFlowDirection.literals.input,
}).default({});

const MotorBase = z.object({
    type: z.literal('motor').default('motor'),
    electrical: z
        .object({
            ports: z.tuple([port]).default([undefined]),
        })
        .default({}),
});

export const MotorValidator = ComponentValidator.merge(MotorBase);

export const MotorPayloadValidator = ComponentPayloadValidator.merge(MotorBase);

export const MotorDefinition: ComponentDefinition = {
    type: 'motor',
    name: 'Motor',
    plural: 'Motors',
    indicator: 'M',
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: true,
    ports: {
        min: 1,
        max: 1,
        powerFlowDirections: ['input', 'bidirectional'],
        allowedControlMethods: ['constant-power', 'power-voltage'],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: MotorValidator,
        payload: MotorPayloadValidator,
    },
};

export type Motor = z.infer<typeof MotorValidator>;
export type MotorPayload = z.infer<typeof MotorPayloadValidator>;
